<div class="flex  justify-center h-full items-center">
    <div class="w-full flex flex-col p-5">
        <h2 class="font-bold">فراموشی رمز عبور</h2>
        <p class="w-full my-3">برای بازیابی کلمه عبور آدرس ایمیل یا شماره موبایل خود را وارد کنید.</p>
        <div class="flex flex-col relative gap-2 my-5">
            <label for="small-test-input"> شماره موبایل یا ایمیل</label>
            <input ihoInput
            class="{{errValidEmailPhone ? '!border-red-300': 'border-2' }} font-bold"
            size="md" id="small-test-input" type="text"
            [(ngModel)]="emailMobile"
            (keyup.enter)="validatePhoneEmail()"
                placeholder=" مثال: 0912345678 / iho@gmail.com ">
                <p *ngIf="errValidEmailPhone" class="text-red-300 text-xs mt-1">
                    فیلد ایمیل یا شماره موبایل اشتباه است.
                </p>
                <p *ngIf="errName"  class="text-red-300 text-xs mt-1">
                    {{errName}}
                </p>
        </div>
        <button mat-raised-button color="primary" 
        class="!font-bold !text-base !h-11"
        [disabled]="!emailMobile || showLoading"  (click)="validatePhoneEmail()" >
            
            <div class="typing-animation" *ngIf="showLoading">
                <span></span>
                <span></span>
                <span></span>
            </div>
        <span *ngIf="!showLoading">     دریافت کد</span>
        
        </button>
        
    </div>
</div>